/** 本地持久化设备 ID（防薅注册；不依赖 FingerprintJS） */
const STORAGE_KEY = 'ds_device_id';

function createId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `ds-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}

export function getOrCreateDeviceId() {
  if (typeof localStorage === 'undefined') return createId();
  try {
    const existing = String(localStorage.getItem(STORAGE_KEY) || '').trim();
    if (existing) return existing;
    const id = createId();
    localStorage.setItem(STORAGE_KEY, id);
    return id;
  } catch {
    return createId();
  }
}
